import React from "react";
import { useIntl } from "react-intl";
import { FaRegTrashAlt } from "react-icons/fa";
import { MdWarning, MdError } from "react-icons/md";
import ControlledSelect from "../../../../components/ControlledInputs/select.jsx";
import ControlledInput from "../../../../components/ControlledInputs/input.jsx";
import {
  RangeItem,
  RangeHeader,
  RangeIndex,
  RemoveButton,
  RangeContent,
  InputRow,
  InputWrapper,
  WarningMessage,
  ErrorMessage,
} from "./styles.js";

const PositionRangeItem = ({
  index,
  control,
  formState,
  availableAreas,
  maxPositions,
  range,
  validationError,
  onRemove,
  isLoading,
  isInitializing,
}) => {
  const intl = useIntl();

  // Proteção contra range undefined durante reset do formulário
  if (!range) {
    return null;
  }

  const canEdit = range.canEdit !== false;
  const canDelete = range.canDelete !== false;
  const hasWarning = range.hasActiveSessions || range.hasPrintedCredentials;

  const hasAreaSelected = range.areaId !== null && range.areaId !== undefined;
  const hasPositionStart = range.positionStart && range.positionStart !== "";

  const canEditArea = canEdit;
  const canEditPositionStart = hasAreaSelected;
  const canEditPositionEnd = hasAreaSelected && hasPositionStart;


  return (
    <RangeItem>
      <RangeHeader>
        <RangeIndex>
          {intl.formatMessage({ id: "totem_position.range" })} {index + 1}
        </RangeIndex>

        {canDelete && (
          <RemoveButton
            type="button"
            onClick={onRemove}
            title={intl.formatMessage({ id: "remove" })}
          >
            <FaRegTrashAlt />
          </RemoveButton>
        )}
      </RangeHeader>

      {hasWarning && (
        <WarningMessage>
          <MdWarning />
          <span>
            {range.hasPrintedCredentials
              ? intl.formatMessage({
                  id: "totem_position.has_printed_credentials",
                })
              : intl.formatMessage({
                  id: "totem_position.has_active_sessions",
                })}
            {!canEdit &&
              ` - ${intl.formatMessage({
                id: "totem_position.only_expansion_allowed",
              })}`}
          </span>
        </WarningMessage>
      )}

      <RangeContent>
        <InputWrapper fullWidth>
          <ControlledSelect
            name={`ranges.${index}.areaId`}
            arrayName="ranges"
            control={control}
            formState={isInitializing ? { errors: {} } : formState}
            label="totem_position.area"
            required={true}
            disabled={!canEditArea || isLoading}
            options={availableAreas}
            isLoading={isLoading}
          />
        </InputWrapper>

        <InputRow>
          <InputWrapper>
            <ControlledInput
              name={`ranges.${index}.positionStart`}
              arrayName="ranges"
              control={control}
              formState={isInitializing ? { errors: {} } : formState}
              label="totem_position.position_start"
              type="number"
              min={1}
              required={true}
              disabled={!canEditPositionStart}
            />
          </InputWrapper>

          <InputWrapper>
            <ControlledInput
              name={`ranges.${index}.positionEnd`}
              arrayName="ranges"
              control={control}
              formState={isInitializing ? { errors: {} } : formState}
              label="totem_position.position_end"
              type="number"
              min={1}
              required={true}
              disabled={!canEditPositionEnd}
              placeholder={
                maxPositions
                  ? String(maxPositions)
                  : intl.formatMessage({
                      id: "totem_position.position_end_placeholder",
                    })
              }
            />
          </InputWrapper>
        </InputRow>

        {validationError && (
          <ErrorMessage>
            <MdError />
            <span>{validationError}</span>
          </ErrorMessage>
        )}
      </RangeContent>
    </RangeItem>
  );
};

export default PositionRangeItem;
